/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.4
 */
import { IPageAuthTranslation } from '../../types';

const initTranslationPageAuth: IPageAuthTranslation = {
    collapse: {
        body: '',
        title: '',
    },
    form: {
        buttonSubmit: '',
        captcha: '',
        labelLogin: '',
        labelPassword: '',
        passwordForget: '',
        subTitle: '',
        title: '',
    },
    formRecovery: {
        answer: '',
        backToAuth: '',
        buttonBack: '',
        buttonSubmit: '',
        captcha: '',
        labelLogin: '',
        subTitle: '',
        title: '',
        ussd: '',
    },
    changePasswordForm: {
        buttonSubmit: '',
        help: '',
        illegalLetters: '',
        illegalLength: '',
        inputLabel1: '',
        inputLabel2: '',
        modal: {
            button: '',
            text: '',
            title: '',
        },
        notEqualsPasswords: '',
        requiredDigit: '',
        requiredLetter: '',
        subTitle: '',
        title: '',
    },
    notice: {
        captchaRequired: '',
        errorLoginForm: '',
        incorrectAnswer: '',
        passwordRecoverBoth: '',
        passwordRecoverMail: '',
        passwordRecoverPhone: '',
    },
};

export default initTranslationPageAuth;
